import styled from 'styled-components';

const StyledBadge = styled.img`
  && {
    display: inline;
    margin-bottom: 1em;
    width: 22vw;
    margin-top: 0.5em;
    @media screen and (max-width: 768px) {
      width: 30%;
    }
    @media screen and (max-width: 700px) {
      width: 40%;
    }
    @media screen and (max-width: 425px) {
      margin-top: 0.6em;
      width: 80%;
    }
  }
`;

export default StyledBadge;
